/**
 * Phase 1.13.2 — recommendation freshness helpers.
 *
 * STALE_AFTER_MS is a starting point. Revisit per real data-steward
 * feedback after a few weeks of usage; the threshold is a constant
 * here so future tuning is a single-file edit.
 */
export const STALE_AFTER_MS = 6 * 30 * 24 * 60 * 60 * 1000; // ~6 months

export function isRecommendationStale(
  recommendedAt: string | null,
  now: number = Date.now(),
): boolean {
  if (!recommendedAt) return false;
  return now - new Date(recommendedAt).getTime() > STALE_AFTER_MS;
}
